import React from "react";
import { useListingModalSwapItemContext } from "./ListingModalSwapItemProvider";
import { useListingModalSwapLimitReachedContext } from "../ListingModalSwapLimitReachedProvider";

type ListingModalSwapItemWrapperProps = React.ComponentProps<"div">;

export const ListingModalSwapItemWrapper = ({
  className,
  children,
  ...props
}: ListingModalSwapItemWrapperProps) => {
  const { state } = useListingModalSwapItemContext();
  const { dispatch } = useListingModalSwapLimitReachedContext();

  const handleSelection = () => {
    dispatch({ listingToReturn: state.currentListing });
  };

  return (
    <div
      className={className}
      onClick={() => {
        handleSelection();
      }}
      {...props}
    >
      {children}
    </div>
  );
};
